import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'signet-tab',
})
export class SignetTab {
  @Prop() tabText: string;

  render() {
    return (
      <Host class="tab-panel" role="tabpanel" tabIndex="0">
        <slot />
      </Host>
    );
  }
}
